export const iconFontAwesomeBuildingsTentArrowDownToLine = (
	<i className="fa-solid fa-tent-arrow-down-to-line"></i>
);
